import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {InsuranceCategoryFamily} from '@lifeislife/lifeislife-domain';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class InsuranceFamilyResolver implements Resolve<InsuranceCategoryFamily> {

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<InsuranceCategoryFamily> | Promise<InsuranceCategoryFamily> | InsuranceCategoryFamily {
    const familyParam = route.paramMap.get('family');
    if (familyParam != null && InsuranceCategoryFamily[familyParam]) {
      return familyParam as InsuranceCategoryFamily;
    } else {
      return null;
    }
  }

}
